import React from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import Datetime from 'react-datetime';
import {EditorPanel, EditorColumn} from '../editor-components';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import {AudioUploader, ImageUploader, VideoUploader} from '../uploaders';

export default class ShowMetadata extends ReactFireComponent {
  constructor(props){
    super(props);
    this.state = {
      metadata: {
        name: "Unnamed Show",
        isSample: false
      }
    }
    this.dataURL = props.dataURL + '/metadata';
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to its firebase realtime
    * database entry
    */
  componentWillMount(){
    this.bindAsObject(this.dataURL, 'metadata');
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.unbind('metadata');
  }
  /** @function handleChange
    * Updates the state of the component based on
    * input field events.
    * @param {InputEvent} event - the event to respond to
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    var metadata = this.state.metadata;
    metadata[name] = value;
    this.setState({
      metadata: metadata
    });
  }
  /** @function handleDatetimeChange
    * Updates the state of the component to reflect
    * a change in a datetime field.
    * @param {string} name - the name of the property to update
    * @param {Moment} moment - a Moment.js object representing the
    * new datetime value.
    */
  handleDatetimeChange(name, moment) {
    var metadata = this.state.metadata;
    metadata[name] = moment.valueOf();
    this.setState({
      metadata: metadata
    });
  }
  /** @function handleBlur
    * Applies the updated state to the firebase database
    */
  handleBlur(event) {
    firebase.database().ref(this.dataURL).set(this.state.metadata);
  }
  /** @function handleImageUpload
    * Applies uploaded images to the state and
    * saves them to the database.
    */
  handleImageUpload(name, url) {
    var metadata = this.state.metadata;
    metadata[name] = url;
    this.setState({
      metadata: metadata
    }, () => this.handleBlur());
  }
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <EditorPanel>
        <EditorColumn>
          <div className="input-group">
            <label htmlFor="name">Name</label><br/>
            <input type="text" name="name"
              value={this.state.metadata.name}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="opens">Opens</label><br/>
            <Datetime
              value={new Date(this.state.metadata.opens)}
              locale="en"
              displayTimeZone="America/Chicago"
              closeOnSelect={true}
              onChange={(moment)=>this.handleDatetimeChange("opens", moment)}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="closes">Closes</label><br/>
            <Datetime
              value={new Date(this.state.metadata.closes)}
              locale="en"
              displayTimeZone="America/Chicago"
              closeOnSelect={true}
              onChange={(moment)=>this.handleDatetimeChange("closes", moment)}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="supportEmail">Support Email</label><br/>
            <input type="email" name="supportEmail"
              value={this.state.metadata.supportEmail}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="isSample">
              <input type="checkbox" name="isSample"
                checked={this.state.metadata.isSample}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                />
              Is a show sample
            </label>
          </div>
          <div className="input-group">
            <AudioUploader
              name="Background Noise"
              value={this.state.metadata.backgroundNoise}
              dataURL={this.props.dataURL + '/backgroundNoise'}
              onUpload={(url)=>this.handleImageUpload('backgroundNoise', url)}
              />
          </div>
          <div className="input-group">
            <VideoUploader
              name="Welcome Video"
              value={this.state.metadata.welcomeVideo}
              dataURL={this.props.dataURL + '/welcomeVideo'}
              onUpload={(url)=>this.handleImageUpload('welcomeVideo', url)}
              />
          </div>
        </EditorColumn>
        <EditorColumn>
          <div className="input-group">
            <ImageUploader
              name="Icon Image"
              value={this.state.metadata.icon}
              dataURL={this.props.dataURL + '/icon'}
              onUpload={(url)=>this.handleImageUpload('icon', url)}
              />
          </div>
          <div className="input-group">
            <ImageUploader
              name="Logo Image"
              value={this.state.metadata.logo}
              dataURL={this.props.dataURL + '/logo'}
              onUpload={(url)=>this.handleImageUpload('logo', url)}
              />
          </div>
          <div className="input-group">
            <ImageUploader
              name="Sponsors Image"
              value={this.state.metadata.sponsors}
              dataURL={this.props.dataURL + '/sponsors'}
              onUpload={(url)=>this.handleImageUpload('sponsors', url)}
              />
          </div>
        </EditorColumn>
      </EditorPanel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/show-editor/show-metadata.js